var store = {
  state: {
    overlayShow: false,
    auth: {
      isAuthenticated: false,
      token: false,
      role: null,
      locations: null,
    },
    languages: {
      es: 'Español',
      en: 'English',
    },
    genders: {
      man: 'Hombre',
      woman: 'Mujer',
      others: 'Otros',
    },
  },
  setOverlayShow(overlayShow) {
    this.state.overlayShow = overlayShow;
  },
  setAuth(isAuthenticated, token, role, locations) {
    this.state.auth.isAuthenticated = isAuthenticated;
    this.state.auth.token = token;
    this.state.auth.role = role;
    this.state.auth.locations = locations;
  },
  getLanguageCodes() {
    return Object.keys(this.state.languages).map((k) => k);
  },
  getLanguageNames() {
    return Object.keys(this.state.languages).map(
      (k) => this.state.languages[k]
    );
  },
};

export default store;
